module.exports = __webpack_public_path__ + "img/Butterfly_00089.91f65c81.png";